/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect } from 'react'
import { useNavigate, useParams, Link } from 'react-router-dom'
import axios from 'axios'
import ReactHtmlParser from 'react-html-parser'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import { positionChangeWidthSm, navbarHeight, footerHeight, swipelyticsTurquoise, profPicDefaultURL, hingeProfileBackgroundColor, hingeProfileImageDimension, tinderProfileItemBackgroundColor, tinderProfileItemBorderColor, tinderProfileTextColor, tinderProfilePromptTextColor, tinderProfileItemDividerOpacity, tinderProfileItemBoxShadow, tinderProfileItemBorderWidth, tinderProfileItemBorderRadius, tinderProfileImageWidth, tinderProfileImageIndicatorWidth, tinderLeadImageHeight, tinderImageHeight } from '../../../../../helpers/variableDefaults'

export const viewTinderNameAndPronounsItem = (datingProfile, width) => {
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
      }}
    >
      <Typography
        sx={{
          // width: '100%',
          width: tinderProfileImageWidth(width),
          color: tinderProfileTextColor,
          // fontWeight: 'bold',
          fontSize: '20px',
        }}
      >
        <strong>{datingProfile.bio.vitalInfo.firstName}</strong> {datingProfile.bio.vitalInfo.age}
      </Typography>

      {'pronouns' in datingProfile.bio.vitalInfo 
        && datingProfile.bio.vitalInfo.pronouns !== 'Prefer not to say' 
        &&
        <Typography
          sx={{
            width: '100%',
            fontStyle: 'italic',
          }}
        >
          {datingProfile.bio.vitalInfo.pronouns}
        </Typography>
      }

    </Box>
  )
}